var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnologyDropped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.521,
    y: 13.336,
    width: 5.668,
    height: 1.417,
    rx: 0.709
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56 2a.709.709 0 00-.708.708v.71h-.125a2 2 0 00-2 2v10.169a2 2 0 002 2h3.668V16.17h-3.25a1 1 0 01-1-1V8.376H15.48v1.418h1.417V5.417a2 2 0 00-2-2h-.125V2.71a.708.708 0 10-1.417 0v.708H6.269V2.71A.709.709 0 005.561 2zM4.145 6.96H15.48V5.833a1 1 0 00-1-1H5.144a1 1 0 00-1 1V6.96z"
  })));
}
export default SvgTechnologyDropped;